import React from "react";
import ComponentTitle from "./ComponentTitle";
import Button from "./Button";
import RowTable from "./RowTable";
import { Excel, inputExcelData } from "../../util/excel";
import COLUMN_LIST_DATA from "./data/columnListData";

const QualityList = ({setInputData, resbody, setSelectedData, stagingStatus, setStagingStatus}) => {
  return (
    <div className="border-gray-400 border-b max-h-96 flex flex-col flex-grow">
      <div className="py-1 border-b border-gray-400 flex justify-between">
        <div className="flex">
          <ComponentTitle title={"☞ 실험 결과"} />
          <div className="ml-2">{`(${resbody ? resbody.resultData.length : 0} 건)`}</div>
        </div>
        {/* <input 
          // buttonAction={() => Excel()} 
            type="file"
            text={"엑셀업로드"}
            className="cursor-pointer"
            accept=".xlsx"
            onChange={(e) => {
              inputExcelData(e.target.files[0])
            }}
          /> */}
        {/* <Button 
          buttonAction={() => Excel(resbody.resultData, COLUMN_LIST_DATA)} 
          buttonText={"엑셀변환"}
          /> */}
      </div>
      <div className="p-2">
        <RowTable columnListData={COLUMN_LIST_DATA} setInputData={setInputData} stagingStatus={stagingStatus} setStagingStatus={setStagingStatus} resbody={resbody} setSelectedData={setSelectedData} />
      </div>
    </div>
  )
}

export default QualityList;